import React from "react";
import CommunityListPage from "../community/components/CommunityListPage";
import { IMMEDIATE_HELP } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function ImmediateHelpPage() {
  useRequireSectionVisible("showUrgentHelp");
  return <CommunityListPage section={IMMEDIATE_HELP} />;
}
